<script>
    import Card from "./card.svelte";
    export let setupURL = "";
    export let image="";
</script>

<Card>
    <div slot="header">
        <h3>Configuration</h3>
    </div>
    <div slot="body">
        <div class="container d-flex h-100">
            <div class="row ">
                <div class="col-12 col-lg-3 col-md-5" style="text-align: center;">       
                    <img src="/images/{image}" class="img-fluid" alt="Responsive image" style=" max-height: 200px;"/>       
                </div>

                <div class="col-12 col-lg-9 col-md-7">
                    <slot name="content" />
                    {#if setupURL != null && setupURL != ""}
                        <a class="btn btn-primary" href={setupURL}>Setup</a>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</Card>
<!-- <Card>
        <div slot="header">
            <h3>Configuration</h3>
        </div>
 

        <div slot="body">
            <div class="container d-flex h-100">
                <div class="row ">
                    <div
                        class="col-12 col-md-3"
                        style="
        text-align: center;">
                        <img
                            src="https://socialistmodernism.com/wp-content/uploads/2017/07/placeholder-image.png?w=640"
                            class="img-fluid"
                            alt="Responsive image"
                            style=" max-height: 200px;" />
                    </div>

                    <div class="col-12 col-md-9">
                        <p class="mt-3">
                            Your school does not currently import data to us
                            from your MIS. This is needed in order to use any
                            services we integrate with.
                        </p>
                        <p style="">
                            Please click the “Setup” button below to configure
                            the import. If you get stuck at any point, please
                            take a look at our
                            <a
                                href="https://nimbus.adept.education/user_guide/import.html"
                                target="_blank">user guide</a>
                            or speak to our support team.
                        </p>

                        <a
                            class="btn btn-primary"
                            href="/app/import/step1">Setup</a>
                    </div>
                </div>
            </div>
            </div>
            </Card> -->
    
